const defaultFont = '"Open Sans", sans-serif';

/**
 * These styles should exactly match those in the Zapier Design System.
 * That said, this list is not exhaustive for some properties, so not every
 * permutation (e.g. fontWeight) is covered.
 *
 * It is completely acceptable to do something like this in your styles:
 *
 * myTextElement: {
 *   ...Typography.subtitle900,
 *   fontWeight: 400,
 * },
 */
export const Typography = {
  // For use cases where styles are unique but the same
  // `fontFamily` should be used.
  base: {
    fontFamily: defaultFont,
  },
  header900: {
    fontFamily: defaultFont,
    fontSize: 70,
    fontWeight: 800,
    letterSpacing: -1,
    lineHeight: '75px',
  },
  header850: {
    fontFamily: defaultFont,
    fontSize: 55,
    fontWeight: 800,
    letterSpacing: -1,
    lineHeight: '60px',
  },
  header800: {
    fontFamily: defaultFont,
    fontSize: 40,
    fontWeight: 800,
    letterSpacing: -1,
    lineHeight: '45px',
  },
  header700: {
    fontFamily: defaultFont,
    fontSize: 32,
    fontWeight: 700,
    letterSpacing: -1,
    lineHeight: '35px',
  },
  subtitle900: {
    fontFamily: defaultFont,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '30px',
  },
  subtitle800: {
    fontFamily: defaultFont,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: '25px',
  },
  subtitle700: {
    fontFamily: defaultFont,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '20px',
  },
  bodyText900: {
    fontFamily: defaultFont,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '25px',
  },
  bodyText800: {
    fontFamily: defaultFont,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '25px',
  },
  altText900: {
    fontFamily: defaultFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
  },
  altText800: {
    fontFamily: defaultFont,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '15px',
  },
  allCaps900: {
    fontFamily: defaultFont,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '20px',
    textTransform: 'uppercase' as 'uppercase',
  },
  allCaps800: {
    fontFamily: defaultFont,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '15px',
    textTransform: 'uppercase' as 'uppercase',
  },
  allCaps700: {
    fontFamily: defaultFont,
    fontSize: 10,
    fontWeight: 700,
    lineHeight: '15px',
    textTransform: 'uppercase' as 'uppercase',
  },
};
export type TypographyName = keyof typeof Typography;
